import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useDataAggregation } from '../../Common/hooks/useAggregationData';
import { useCadUniqueChartsDataContext } from './hooks/useCadUniqueChartsDataContext';

export const PeopleAnual = () => {
    const { chartData } = useCadUniqueChartsDataContext();

    const rawData = chartData?.peopleAnual || [];

    //const consolidatedData = useDataAggregation(rawData, 'ano', ['value']);

    const series = [
        {
            name: 'Pessoas Cadastradas',
            data: rawData.map(item => item.months?.[0]?.value ?? Number(item.value))
        }
    ];

    return (
        <SimpleBars
            title={'Evolução anual das pessoas cadastradas'}
            horizontal={false}
            subtitles={rawData?.map((item) => getYearLabel(item.ano))}
            series={series}
            stacked
        />
    );
};
